export interface ITenantConfig {
	LOCIZE_PROJECT_ID: string;
	LOCIZE_API_KEY: string;
	LOCIZE_SAVE_MISSING: boolean;
}

export default class ConfigService {
	static config: ITenantConfig = {
		LOCIZE_API_KEY: import.meta.env.VITE_LOCIZE_API_KEY ?? '3b61c8c9-9391-44e6-8350-0f590190fce3',
		LOCIZE_PROJECT_ID:
			import.meta.env.VITE_LOCIZE_PROJECT_ID ?? '1411fc65-e229-4585-af21-a35561f17f5d',
		LOCIZE_SAVE_MISSING: false,
	};

	static configsUrl = import.meta.env.VITE_CONFIGS_URL ?? 'https://ontreams.com';

	static async fetchConfigForHost(
		host: string,
		isDevEnvironment: boolean = false,
	): Promise<ITenantConfig> {
		if (isDevEnvironment) {
			return Promise.resolve(ConfigService.config);
		}

		const config: ITenantConfig = {
			LOCIZE_API_KEY: import.meta.env.VITE_LOCIZE_API_KEY ?? '3b61c8c9-9391-44e6-8350-0f590190fce3',
			LOCIZE_PROJECT_ID:
				import.meta.env.VITE_LOCIZE_PROJECT_ID ?? '1411fc65-e229-4585-af21-a35561f17f5d',
			LOCIZE_SAVE_MISSING: true,
		};
		ConfigService.config = config;
		return Promise.resolve(config);
	}
}
